module.exports = __webpack_public_path__ + "static/assets/78091e695615cb3534a6569ea101bdc4.svg";